import StatusFilterTabs from '../../../components/shared/StatusFilterTabs';
import { ORDER_STATUS_FILTER_TABS } from '../../../utils/status';
import type { OrderAnalytics, OrderFilter } from '../models/types';

type TransactionFiltersProps = {
  statusFilter: OrderFilter;
  onStatusFilterChange: (value: OrderFilter) => void;
  loading: boolean;
  analytics: OrderAnalytics;
};

const TAB_COUNT_KEY: Record<string, keyof OrderAnalytics> = {
  all: 'totalOrdersCount',
  completed: 'totalCompletedTransactions',
  failed: 'totalFailedTransactions',
  pending: 'totalPendingTransactions',
  processing: 'totalProcessingTransactions',
  awaiting_checkout: 'totalAwaitingCheckoutTransactions',
  refunded: 'totalRefundTransactions',
  chargeback: 'totalChargebackTransactions',
};

export default function TransactionFilters({
  statusFilter,
  onStatusFilterChange,
  loading,
  analytics,
}: TransactionFiltersProps) {
  return (
    <StatusFilterTabs
      tabs={ORDER_STATUS_FILTER_TABS}
      value={statusFilter}
      onChange={(value) => onStatusFilterChange(value as OrderFilter)}
      disabled={loading}
      ariaLabel="Transaction status"
      className="min-w-0 flex-1"
      getCount={(tab) => {
        const key = typeof tab === 'string' ? tab : tab.value;
        const countKey = TAB_COUNT_KEY[key];
        return countKey ? Number(analytics[countKey] ?? 0) : 0;
      }}
    />
  );
}
